module.exports = __webpack_public_path__ + "static/media/celgene_logo.f25a3cf6.png";